module.exports = __webpack_public_path__ + "img/P150T_weapon_39.6411d712.png";